export const videoIds: Record<string, string> = {
  pt: "33VTEInkVBk",
  es: "AExkTq5pUEM",
  en: "dAgU_ALJllw",
};

export const sensingVideoIframeId = "sensing-youtube-iframe";
